import { Expose, Type } from "class-transformer";
import { IsArray, IsNumber, ValidateNested } from "class-validator";
import { PoetryEntity } from "../../entity";

export class GetAllPoetryDTO {
  @Expose()
  @ValidateNested()
  @IsArray()
  @Type(() => PoetryEntity)
  data!: PoetryEntity[];

  @Expose()
  @IsNumber()
  count!: number;

  @Expose()
  @IsNumber()
  page!: number;

  @Expose()
  @IsNumber()
  pageSize!: number;
}
